import React, {useContext, createContext,useState} from 'react';
const ViewContext = createContext();

const AS2CommStatusContextProvider = ({children}) => {

    const [as2QueryParams,setAs2QueryParams]= useState({
        "fromDate": new Date(),
        "toDate": new Date(),
        "supplierNumber":"",
        "direction":"",
        "as2SenderId":"",
        "as2ReceiverId":"",
        "unitCode":"",
        "forceUpdate": 0
    });


    const contextValues = {
        as2QueryParams,setAs2QueryParams
    }

    return (
        <ViewContext.Provider value={contextValues}>
            {children}
        </ViewContext.Provider>
    );


}

const useAS2CommStatusContextProvider = () => {
    const context = useContext(ViewContext);

    if (context === undefined) {
        throw new Error('useContextProvider must be used within ContextProvider.');
    }

    return context;

}

export {
    AS2CommStatusContextProvider,
    useAS2CommStatusContextProvider
}
